export const INITIAL_PAGE_PRIMARY_FONT = 'h2';
export const INITIAL_PAGE_SECONDARY_FONT = 'h4';
export const DEFAULT_FONTFAMILY = 'Inter';

export type FontType = 'google' | 'custom';

export interface FontFamilyOption {
  label: string;
  value: string;
  type: FontType;
}

// Metadata for custom (non-Google) fonts hosted on CDN.
// cssPath is relative to CDN_BASE_URL.
export const CUSTOM_FONT_CONFIG: Record<
  string,
  { family: string; cssPath: string }
> = {
  Satoshi: {
    family: 'Satoshi',
    cssPath: '/fonts/satoshi/satoshi.css',
  },
};

export const CLIENT_FONTFAMILY_OPTIONS: FontFamilyOption[] = [
  {
    label: 'Abhaya Libre',
    value: 'Abhaya+Libre',
    type: 'google',
  },
  {
    label: 'Alegreya',
    value: 'Alegreya',
    type: 'google',
  },
  {
    label: 'Alegreya Sans',
    value: 'Alegreya+Sans',
    type: 'google',
  },
  {
    label: 'Andada Pro',
    value: 'Andada+Pro',
    type: 'google',
  },
  {
    label: 'Archivo',
    value: 'Archivo',
    type: 'google',
  },
  {
    label: 'Asap Condensed',
    value: 'Asap+Condensed',
    type: 'google',
  },
  {
    label: 'Barlow',
    value: 'Barlow',
    type: 'google',
  },
  {
    label: 'Bitter',
    value: 'Bitter',
    type: 'google',
  },
  {
    label: 'Chivo',
    value: 'Chivo',
    type: 'google',
  },
  {
    label: 'Cormorant',
    value: 'Cormorant',
    type: 'google',
  },
  {
    label: 'DM Sans',
    value: 'DM+Sans',
    type: 'google',
  },
  {
    label: 'Dosis',
    value: 'Dosis',
    type: 'google',
  },
  {
    label: 'Encode Sans',
    value: 'Encode+Sans',
    type: 'google',
  },
  {
    label: 'Enriqueta',
    value: 'Enriqueta',
    type: 'google',
  },
  {
    label: 'Epilogue',
    value: 'Epilogue',
    type: 'google',
  },
  {
    label: 'Fira Sans',
    value: 'Fira+Sans',
    type: 'google',
  },
  {
    label: 'Frank Ruhl Libre',
    value: 'Frank+Ruhl+Libre',
    type: 'google',
  },
  {
    label: 'Gelasio',
    value: 'Gelasio',
    type: 'google',
  },
  {
    label: 'Hahmlet',
    value: 'Hahmlet',
    type: 'google',
  },
  {
    label: 'Inconsolata',
    value: 'Inconsolata',
    type: 'google',
  },
  {
    label: 'Inter',
    value: 'Inter',
    type: 'google',
  },
  {
    label: 'JetBrains Mono',
    value: 'JetBrains+Mono',
    type: 'google',
  },
  {
    label: 'Lato',
    value: 'Lato',
    type: 'google',
  },
  {
    label: 'Libre Franklin',
    value: 'Libre+Franklin',
    type: 'google',
  },
  {
    label: 'Lora',
    value: 'Lora',
    type: 'google',
  },
  {
    label: 'Manrope',
    value: 'Manrope',
    type: 'google',
  },
  {
    label: 'Montserrat',
    value: 'Montserrat',
    type: 'google',
  },
  {
    label: 'Mukta',
    value: 'Mukta',
    type: 'google',
  },
  {
    label: 'Mulish',
    value: 'Mulish',
    type: 'google',
  },
  {
    label: 'Noto Sans',
    value: 'Noto+Sans',
    type: 'google',
  },
  {
    label: 'Nunito',
    value: 'Nunito',
    type: 'google',
  },
  {
    label: 'Oswald',
    value: 'Oswald',
    type: 'google',
  },
  {
    label: 'Open Sans',
    value: 'Open Sans',
    type: 'google',
  },
  {
    label: 'Playfair Display',
    value: 'Playfair+Display',
    type: 'google',
  },
  {
    label: 'Poppins',
    value: 'Poppins',
    type: 'google',
  },
  {
    label: 'Proza Libre',
    value: 'Proza+Libre',
    type: 'google',
  },
  {
    label: 'Quicksand',
    value: 'Quicksand',
    type: 'google',
  },
  {
    label: 'Raleway',
    value: 'Raleway',
    type: 'google',
  },
  {
    label: 'Roboto',
    value: 'Roboto',
    type: 'google',
  },
  {
    label: 'Roboto Slab',
    value: 'Roboto+Slab',
    type: 'google',
  },
  {
    label: 'Rokkitt',
    value: 'Rokkitt',
    type: 'google',
  },
  {
    label: 'Rubik',
    value: 'Rubik',
    type: 'google',
  },
  {
    label: 'Satoshi',
    value: 'Satoshi',
    type: 'custom',
  },
  {
    label: 'Sora',
    value: 'Sora',
    type: 'google',
  },
  {
    label: 'Source Sans Pro',
    value: 'Source+Sans+Pro',
    type: 'google',
  },
  {
    label: 'Space Grotesk',
    value: 'Space+Grotesk',
    type: 'google',
  },
  {
    label: 'Spectral',
    value: 'Spectral',
    type: 'google',
  },
  {
    label: 'Syne',
    value: 'Syne',
    type: 'google',
  },
  {
    label: 'Unbounded',
    value: 'Unbounded',
    type: 'google',
  },
  {
    label: 'Vollkorn',
    value: 'Vollkorn',
    type: 'google',
  },
  {
    label: 'Work Sans',
    value: 'Work+Sans',
    type: 'google',
  },
];
